import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

interface StripeState {
  readonly isLoading: boolean;
  readonly loaded: boolean;
  readonly forms: {
    readonly [elementId: string]: {
      readonly submitting: boolean;
      readonly error: Maybe<string>;
      readonly isEmpty: boolean;
    };
  };
}

const initialState: StripeState = {
  isLoading: false,
  loaded: false,
  forms: {},
};

function reducer(state: StripeState = initialState, action: ActionTypes): StripeState {
  switch (action.type) {
    case ActionKeys.STRIPE_LOAD:
      return {
        ...state,
        isLoading: true,
        loaded: false,
      };
    case ActionKeys.STRIPE_LOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loaded: true,
      };
    case ActionKeys.STRIPE_CREATE_ELEMENT_SUCCESS:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.elementId]: {
            submitting: false,
            error: null,
            isEmpty: true,
          },
        },
      };
    case ActionKeys.STRIPE_CREATE_TOKEN:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.payload.elementId]: {
            ...state.forms[action.payload.elementId],
            submitting: true,
          },
        },
      };
    case ActionKeys.STRIPE_CREATE_TOKEN_SUCCESS:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.elementId]: {
            ...state.forms[action.elementId],
            submitting: false,
          },
        },
      };
    case ActionKeys.STRIPE_SET_FORM_ERROR:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.elementId]: {
            ...state.forms[action.elementId],
            error: action.payload.errorMessage,
            submitting: false,
          },
        },
      };
    case ActionKeys.STRIPE_CLEAR_FORM_ERROR:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.elementId]: {
            ...state.forms[action.elementId],
            error: null,
          },
        },
      };
    case ActionKeys.STRIPE_CANCEL_FORM_SUBMISSION:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.elementId]: {
            ...state.forms[action.elementId],
            submitting: false,
            error: null,
          },
        },
      };
    case ActionKeys.STRIPE_SET_ELEMENT_EMPTY:
      return {
        ...state,
        forms: {
          ...state.forms,
          [action.elementId]: {
            ...state.forms[action.elementId],
            isEmpty: action.isEmpty,
          },
        },
      };

    default:
      return state;
  }
}

export default reducer;

export { StripeState };
